import { styled } from '@mui/material'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'

interface IBorderLinearProgressProps {
  backgroundColor?: string
}

export const StyledBorderLinearProgress = styled(LinearProgress)<IBorderLinearProgressProps>(
  ({ theme, backgroundColor = '#1F0E72' }) => ({
    height: 10,
    borderRadius: 100,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#E9E7F1',
      ...theme.applyStyles('dark', {
        backgroundColor: '#E9E7F1',
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 100,
      backgroundColor,
      ...theme.applyStyles('dark', {
        backgroundColor,
      }),
    },
  })
)
